import { injectIntl } from "react-intl";

const OfferDelete = (props) => {
  const deleteTitle = props.deleteFromEverflow
    ? "Delete Offers from Schedsmart & Everflow?"
    : "Delete Offers from Schedsmart?";
  const deleteWarning = props.deleteFromEverflow
    ? "Are you sure you want to delete this offers from Schedsmart and Everflow? This action cannot be undone."
    : "Are you sure you want to delete this offers from Schedsmart? This action cannot be undone.";

  const deleteOffer = () => {
    if (props.onConfirmDelete) {
      props.onConfirmDelete();
      return;
    }
  };

  return (
    <div className="NewStrategyModalOverlay z-[999]">
      <div className="DeleteStrategyModal">
        <div className={"w-full flex justify-between"}>
          <div className={"DeleteStrategy"}>
            <img
              alt={"Logo"}
              src={"/media/icons/deleteIcon.svg"}
              className={"w-[18px] h-[18px]"}
            />
            {deleteTitle}
          </div>
          <button className={"CloseIconButton"} onClick={props.closeModal}>
            <img
              alt={"Logo"}
              src={"/media/icons/closeIcon.svg"}
              className={"w-5 h-5"}
            />
          </button>
        </div>
        <div className={"flex flex-col gap-4 w-full"}>
          <div className={"HorizontalDivider"}></div>
          <div className={"StrategyDeleteWarning"}>{deleteWarning}</div>
          <div className={"HorizontalDivider"}></div>
        </div>
        <div className={"modal-actions"}>
          <button className={"CloseButton"} onClick={props.closeModal}>
            Cancel
          </button>
          <button className={"DeleteButton"} onClick={deleteOffer}>
            Delete
          </button>
        </div>
      </div>
    </div>
  );
};

export default injectIntl(OfferDelete);
